import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useCampaignsLabelsEnabled } from "@/modules/campaigns/campaignsLabelsAccess";

/** Blocks Campaigns / Labels URLs when the current account is not on the allowlist. */
export function CampaignsLabelsRoute({ children }: { children: ReactNode }) {
  const enabled = useCampaignsLabelsEnabled();
  if (!enabled) return <Navigate to="/" replace />;
  return children;
}
